module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/sx-ce647f25cbbcdb00ed0d4be53bff5d32.svg";